import { TipoPreviaMensagemEnum } from '../../shared/enum/tipo-previa-mensagem.enum';
import { InfoArquivo } from '../models/info-arquivo.model';

export const CLASSE_FONTE_CHAT = 'chat-redesign';

export const CURVA_ANIMACAO = 'cubic-bezier(0.2, 0, 0, 1)';
export const CURVA_MOLA_ANIMACAO = 'cubic-bezier(0.34, 1.56, 0.64, 1)';

export const EXTENSOES_IMAGEM = ['jpg', 'jpeg', 'png', 'bmp', 'ico', 'gif', 'svg', 'webp'];
export const EXTENSOES_VIDEO = ['mp4', 'mov'];
export const EXTENSOES_AUDIO = ['mp3', 'wav', 'ogg', 'opus', 'webm', 'm4a', 'aac'];
export const EXTENSOES_DOWNLOAD = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];
export const EXTENSAO_FIGURINHA = 'webp';

export const TIPO_PREVIA_POR_TIPO_META: Record<string, TipoPreviaMensagemEnum> = {
  image: TipoPreviaMensagemEnum.FOTO,
  video: TipoPreviaMensagemEnum.VIDEO,
  audio: TipoPreviaMensagemEnum.AUDIO,
  sticker: TipoPreviaMensagemEnum.FIGURINHA,
  document: TipoPreviaMensagemEnum.DOCUMENTO
};

export const ROTULOS_TIPO_PREVIA: Record<TipoPreviaMensagemEnum, string> = {
  [TipoPreviaMensagemEnum.TEXTO]: 'Mensagem',
  [TipoPreviaMensagemEnum.FOTO]: 'Foto',
  [TipoPreviaMensagemEnum.VIDEO]: 'Vídeo',
  [TipoPreviaMensagemEnum.AUDIO]: 'Áudio',
  [TipoPreviaMensagemEnum.FIGURINHA]: 'Figurinha',
  [TipoPreviaMensagemEnum.DOCUMENTO]: 'Documento',
  [TipoPreviaMensagemEnum.REACAO]: 'Reação',
  [TipoPreviaMensagemEnum.TEMPLATE]: 'Template',
  [TipoPreviaMensagemEnum.DISPARO]: 'Disparo'
};

export const VELOCIDADES_MIDIA = [1, 1.5, 2];

export const PASTA_ICONES_ARQUIVO = './assets/icones/redesign/files-icons';
export const INFO_ARQUIVO_PDF: InfoArquivo = { icone: `${PASTA_ICONES_ARQUIVO}/pdf.svg`, cor: '#E5252A', rotulo: 'Documento PDF' };
export const INFO_ARQUIVO_TEXTO: InfoArquivo = { icone: `${PASTA_ICONES_ARQUIVO}/file-text.svg`, cor: '#2684FC', rotulo: 'Documento de texto' };
export const INFO_ARQUIVO_PLANILHA: InfoArquivo = { icone: `${PASTA_ICONES_ARQUIVO}/excel.svg`, cor: '#1A8038', rotulo: 'Planilha' };
export const INFO_ARQUIVO_APRESENTACAO: InfoArquivo = { icone: `${PASTA_ICONES_ARQUIVO}/presentation.svg`, cor: '#C13B1B', rotulo: 'Apresentação' };
export const INFO_ARQUIVO_OUTRO: InfoArquivo = { icone: `${PASTA_ICONES_ARQUIVO}/file.svg`, cor: '#C4C4C4', rotulo: 'Arquivo' };
